import { render, staticRenderFns } from "./EditorDxfDialog.vue?vue&type=template&id=63a32a1e&scoped=true&"
import script from "./EditorDxfDialog.vue?vue&type=script&lang=js&"
export * from "./EditorDxfDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditorDxfDialog.vue?vue&type=style&index=0&id=63a32a1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a32a1e",
  null
  
)

export default component.exports